import Typography from '@/common/components/base/typography/Typography';
import LoadingPage from '@/common/pages/LoadingPage';
import SubstitutionPartsCard from '@/modules/adjusterReportModules/IncidentParticipants/components/expert/SubstitutionPartsCard/SubstitutionPartsCard';
import { ISubstitutionPartsOptions } from '@/modules/adjusterReportModules/IncidentParticipants/components/expert/SubstitutionPartsCard/SubstitutionPartsCard.type';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useId, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';
import NotFoundIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/wages-noResualt.svg?react';
import MoneyIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/moneys.svg?react';
import { getBodyWagesListQueryOption } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyWagesList/getBodyWagesListQueryOption';
import { getBodySingleWagesQueryOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodySingleWages/getBodySingleWagesQueryOptions';
import BodyWagesModal from '@/modules/adjusterReportModules/Insurer-information/components/expert/modals/BodyWagesModal';
import BodyRemoveWagesModal from '@/modules/adjusterReportModules/Insurer-information/components/expert/BodyRemoveWagesModal';

const BodyWagesList = ({ isEditable = true }: { isEditable?: boolean }) => {
  const { id } = useParams();
  const [wagesId, setWagesId] = useState<number>();
  const [removeModal, setRemoveModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [wagesName, setWagesName] = useState<string>('');
  const randomId = useId();
  const {
    data: wagesList,
    isPending: loading,
    refetch: refetchWagesList,
  } = useQuery(getBodyWagesListQueryOption({ id: +id! }));

  const { data: getSingleWages, refetch } = useQuery(
    getBodySingleWagesQueryOptions({
      id: +id!,
      wages_id: +wagesId!,
    }),
  );

  const openFormModalHandler = (id: number) => {
    setWagesId(id);
    setOpenModal(true);
  };

  useEffect(() => {
    if (wagesId) {
      refetch();
    }
  }, [wagesId, refetch, openModal]);

  const removeModalHandler = (wagesId: number) => {
    setWagesId(wagesId);
    const wagesName =
      wagesList?.wages.find((item: any) => item.id === wagesId)?.title ?? '';
    setWagesName(wagesName?.toString() ?? '');
    setRemoveModal(true);
  };
  return (
    <Box
      px={16}
      py={8}
      border="1px dashed"
      borderColor="gray-1"
      borderRadius={8}
      mt={8}
    >
      <BodyRemoveWagesModal
        removeModal={removeModal}
        setRemoveModal={setRemoveModal}
        wagesId={+wagesId!}
        wagesName={wagesName}
        completeRemove={() => refetchWagesList()}
      />
      <BodyWagesModal
        open={openModal}
        setOpenModal={() => {
          setOpenModal(false);
        }}
        formData={getSingleWages?.wages}
        onComplete={() => {
          refetchWagesList();
        }}
      />
      <Box display="flex" alignItems="center" gap={8}>
        <Typography textStyle="b1" color="purple-1">
          لیست اجرت تعمیرات
        </Typography>
        {!!wagesList?.count && wagesList?.count > 0 && (
          <BodyWagesCount count={wagesList.count} />
        )}
      </Box>
      {!!wagesList?.total_price && wagesList?.total_price > 0 && (
        <BodyWagesTotalPrice totalPrice={wagesList.total_price} />
      )}
      {wagesList?.count && wagesList.count > 0 ? (
        <Box mt={16}>
          {loading ? (
            <LoadingPage />
          ) : (
            <Box>
              {wagesList?.cartData?.map((item, index) => (
                <SubstitutionPartsCard
                  index={index}
                  key={`${randomId + Math.random()}-id`}
                  data={item as ISubstitutionPartsOptions[]}
                  editAble={isEditable}
                  id={wagesList?.wages[index]?.id ?? 0}
                  edit={(id) => openFormModalHandler(id)}
                  remove={(id) => removeModalHandler(id)}
                  icon={<MoneyIcon />}
                />
              ))}
            </Box>
          )}
        </Box>
      ) : (
        <Box
          w="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          gap={16}
          mt={22}
        >
          <NotFoundIcon />
          <Typography textStyle="b3" color="black-3">
            لوازم تعویضی‌ای ثبت نشده است.
          </Typography>
        </Box>
      )}
    </Box>
  );
};
export default BodyWagesList;

const BodyWagesCount = (data: { count: number }) => {
  return (
    <Box
      bg="purple-6"
      w={47}
      h={24}
      color="purple"
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius={8}
    >
      <Typography textStyle="b4" color="purple-1">
        {`${data.count} مورد`}
      </Typography>
    </Box>
  );
};

const BodyWagesTotalPrice = (data: { totalPrice: number }) => {
  return (
    <Box
      w="100%"
      bg="green-4"
      px={8}
      py={5}
      borderRadius={4}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mt={16}
    >
      <Typography textStyle="b4" color="green-1">
        مجموع هزینه :
      </Typography>
      <Typography textStyle="b4" color="green-1">
        {`${data?.totalPrice?.toLocaleString('fa')} ریال`}
      </Typography>
    </Box>
  );
};
